import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyList: [],
  searchedCompany: null,
  companySelectedAddress: null,
  createdCompany: null,
  isCompanySearched: false,
  companyPastOrders: null,
  companyActiveOrders: [],

  accountManagerList: [],
  bankNamesList: [],
  bankNamesStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  accountManagersStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyList: (state, action) => {
      state.companyList = action.payload;
    },
    setSearchedCompany: (state, action) => {
      state.searchedCompany = action.payload;
      state.isCompanySearched = true;
    },
    setAccountManagerList: (state, action) => {
      state.accountManagerList = action.payload;
    },
    setBankNamesList: (state, action) => {
      state.bankNamesList = action.payload;
    },
    setBankNamesStatus: (state, action) => {
      state.bankNamesStatus = action.payload;
    },
    setAccountManagersStatus: (state, action) => {
      state.accountManagersStatus = action.payload;
    },
    clearSearchedCompany: (state) => {
      state.searchedCompany = null;
      state.isCompanySearched = false;
    },
    setCompanySelectedAddress: (state, action) => {
      state.companySelectedAddress = action.payload;
    },
    setCreatedCompany: (state, action) => {
      state.createdCompany = action.payload;
    },
    setIsCompanySearched: (state, action) => {
      state.isCompanySearched = action.payload;
    },
    setCompanyPastOrders: (state, action) => {
      state.companyPastOrders = action.payload;
    },
    setCompanyActiveOrders: (state, action) => {
      // Filter and store only the required fields for active orders
      state.companyActiveOrders = action.payload.filter(order => 
        ["Ready for Dispatch", "Preparing", "On the way", "Submitted", "Accepted", "Delivered"]
        .includes(order.order_status)
      ).map(order => ({
        address_id: order.address_id,
        restaurant_id: order.restaurant_id,
        service_type: order.service_type,
        branch_id: order.branch_id
      }));
    },

          clearCompanyDataExceptList: (state) => {
        // Clear all company data except companyList when new company is searched/selected
        state.searchedCompany = null;
        state.companySelectedAddress = null;
        state.createdCompany = null;
        state.isCompanySearched = false;
        state.companyPastOrders = null;
        state.companyActiveOrders = [];
      },
    addAddressToCompany: (state, action) => {
      const { companyId, newAddress } = action.payload;
      
      // Find the company in companyList
      const companyIndex = state.companyList.findIndex(company => company.id === companyId);
      
      if (companyIndex !== -1) {
        // If company doesn't have addresses array, create one
        if (!state.companyList[companyIndex].addresses) {
          state.companyList[companyIndex].addresses = [];
        }
        
        // Add the new address to the company's addresses array
        state.companyList[companyIndex].addresses.push(newAddress);
        
        // Also update searchedCompany if it's the same company
        if (state.searchedCompany && state.searchedCompany.id === companyId) {
          if (!state.searchedCompany.addresses) {
            state.searchedCompany.addresses = [];
          }
          state.searchedCompany.addresses.push(newAddress);
        }
      }
    },
    updateCompanyAddress: (state, action) => {
      const { companyId, addressId, updatedAddress } = action.payload;
      
      // Find the company in companyList
      const companyIndex = state.companyList.findIndex(company => company.id === companyId);
      
      if (companyIndex !== -1 && state.companyList[companyIndex].addresses) {
        // Find and update the address in companyList
        const addressIndex = state.companyList[companyIndex].addresses.findIndex(
          address => address.id === addressId
        );
        
        if (addressIndex !== -1) {
          state.companyList[companyIndex].addresses[addressIndex] = updatedAddress;
        }
        
        // Also update searchedCompany if it's the same company
        if (state.searchedCompany && state.searchedCompany.id === companyId && state.searchedCompany.addresses) {
          const searchedAddressIndex = state.searchedCompany.addresses.findIndex(
            address => address.id === addressId
          );
          
          if (searchedAddressIndex !== -1) {
            state.searchedCompany.addresses[searchedAddressIndex] = updatedAddress;
          }
        }
      }
    },
  },
});

export const {
  setCompanyList,
  setSearchedCompany,
  clearSearchedCompany,
  setCompanySelectedAddress,
  setCreatedCompany,
  setIsCompanySearched,
  setCompanyPastOrders,
  setCompanyActiveOrders,
  clearCompanyDataExceptList,
  addAddressToCompany,
  updateCompanyAddress,
  setAccountManagerList,
  setBankNamesList,
  setBankNamesStatus,
  setAccountManagersStatus,
} = companySlice.actions;

export default companySlice.reducer; 